import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("bacc423d2b", "._556ae8be2a7ddc8e__disabled{pointer-events:none;position:relative}._556ae8be2a7ddc8e__disabled:after{content:\"\";inset:0;position:absolute}._556ae8be2a7ddc8e__disabled *{pointer-events:none}");
}
export default {"disabled":"_556ae8be2a7ddc8e__disabled"};
